import React from 'react';
import { AlertCircleIcon, TrendingUpIcon, TrendingDownIcon, DollarSignIcon } from 'lucide-react';
export function EnergyUsage() {
  const dailyUsage = [{
    day: 'Mon',
    usage: 2.3
  }, {
    day: 'Tue',
    usage: 2.1
  }, {
    day: 'Wed',
    usage: 3.5
  }, {
    day: 'Thu',
    usage: 2.8
  }, {
    day: 'Fri',
    usage: 3.2
  }, {
    day: 'Sat',
    usage: 4.1
  }, {
    day: 'Sun',
    usage: 3.8
  }];
  const maxUsage = Math.max(...dailyUsage.map(item => item.usage));
  return <div className="space-y-6" data-id="element-163">
      <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-164">
        <h2 className="text-xl font-semibold mb-4" data-id="element-165">Energy Consumption</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-166">
          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-167">
            <p className="text-gray-500 mb-1" data-id="element-168">Today's Usage</p>
            <div className="flex items-end gap-2" data-id="element-169">
              <span className="text-2xl font-bold" data-id="element-170">3.8 kWh</span>
              <span className="text-green-600 text-sm flex items-center" data-id="element-171">
                <TrendingDownIcon size={14} className="mr-1" data-id="element-172" />
                5%
              </span>
            </div>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-173">
            <p className="text-gray-500 mb-1" data-id="element-174">This Month</p>
            <div className="flex items-end gap-2" data-id="element-175">
              <span className="text-2xl font-bold" data-id="element-176">87.2 kWh</span>
              <span className="text-red-600 text-sm flex items-center" data-id="element-177">
                <TrendingUpIcon size={14} className="mr-1" data-id="element-178" />
                12%
              </span>
            </div>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-179">
            <p className="text-gray-500 mb-1" data-id="element-180">Estimated Bill</p>
            <div className="flex items-end gap-2" data-id="element-181">
              <span className="text-2xl font-bold" data-id="element-182">1,053,750₫</span>
              <span className="text-red-600 text-sm flex items-center" data-id="element-183">
                <TrendingUpIcon size={14} className="mr-1" data-id="element-184" />
                8%
              </span>
            </div>
          </div>
        </div>
        <div className="mb-6" data-id="element-185">
          <h3 className="text-lg font-medium mb-4" data-id="element-186">Daily Energy Usage</h3>
          <div className="h-60 flex items-end" data-id="element-187">
            {dailyUsage.map((item, index) => <div key={index} className="flex-1 flex flex-col items-center" data-id="element-188">
                <div className="w-full max-w-[40px] bg-green-500 rounded-t-sm mx-auto" style={{
              height: `${item.usage / maxUsage * 180}px`
            }} data-id="element-189"></div>
                <span className="text-xs mt-2 text-gray-600" data-id="element-190">{item.day}</span>
              </div>)}
          </div>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-191">
        <div className="flex items-start justify-between mb-4" data-id="element-192">
          <h2 className="text-xl font-semibold" data-id="element-193">Bill Guard</h2>
          <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-xs font-medium" data-id="element-194">
            Active
          </span>
        </div>
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6 flex items-start" data-id="element-195">
          <AlertCircleIcon className="text-yellow-500 mr-3 mt-0.5 flex-shrink-0" size={20} data-id="element-196" />
          <div data-id="element-197">
            <h4 className="font-medium text-yellow-800" data-id="element-198">
              Approaching Budget Limit
            </h4>
            <p className="text-sm text-yellow-700" data-id="element-199">
              You've used 85% of your monthly energy budget. Consider reducing
              usage to avoid exceeding your limit.
            </p>
          </div>
        </div>
        <div className="mb-4" data-id="element-200">
          <div className="flex justify-between mb-1" data-id="element-201">
            <span className="text-sm text-gray-600" data-id="element-202">Monthly Budget</span>
            <span className="text-sm font-medium" data-id="element-203">1,250,000₫</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-204">
            <div className="bg-yellow-500 h-2.5 rounded-full" style={{
            width: '85%'
          }} data-id="element-205"></div>
          </div>
          <div className="flex justify-between mt-1" data-id="element-206">
            <span className="text-xs text-gray-500" data-id="element-207">Used: 1,053,750₫</span>
            <span className="text-xs text-gray-500" data-id="element-208">Remaining: 196,250₫</span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-209">
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-210">
            <h4 className="font-medium mb-2 flex items-center" data-id="element-211">
              <TrendingUpIcon size={18} className="mr-2 text-green-600" data-id="element-212" />
              High Usage Devices
            </h4>
            <ul className="space-y-2" data-id="element-213">
              <li className="flex justify-between items-center" data-id="element-214">
                <span className="text-sm text-gray-600" data-id="element-215">
                  Kitchen Smart Plug
                </span>
                <span className="text-sm font-medium" data-id="element-216">120W</span>
              </li>
              <li className="flex justify-between items-center" data-id="element-217">
                <span className="text-sm text-gray-600" data-id="element-218">Bedroom AC</span>
                <span className="text-sm font-medium" data-id="element-219">850W</span>
              </li>
              <li className="flex justify-between items-center" data-id="element-220">
                <span className="text-sm text-gray-600" data-id="element-221">Living Room TV</span>
                <span className="text-sm font-medium" data-id="element-222">65W</span>
              </li>
            </ul>
          </div>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-223">
            <h4 className="font-medium mb-2 flex items-center" data-id="element-224">
              <DollarSignIcon size={18} className="mr-2 text-green-600" data-id="element-225" />
              Savings Tips
            </h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-226">
              <li data-id="element-227">• Turn off AC when not in use (Save ~300,000₫/month)</li>
              <li data-id="element-228">
                • Unplug kitchen appliances overnight (Save ~125,000₫/month)
              </li>
              <li data-id="element-229">• Reduce TV brightness setting (Save ~75,000₫/month)</li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
}